import requestv2 from "~/utils/http-v2";

const contractApi = {
	gets : async (params) => {
		const url = 'v2/contract';
		return await requestv2.get(url, {params});
	},
	search : async (params) => {
		const url = 'v2/contract/search';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/contract';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/contract/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/contract/${id}`;
		return await requestv2.delete(url);
	},
	status : async (params) => {
		const url = `v2/contract/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	paperStatus : async (params) => {
		const url = `v2/contract/paper-status/${params.id}`;
		return await requestv2.post(url, params);
	},
	note : async (id) => {
		const url = 'v2/contract/note/' + id;
		return await requestv2.get(url);
	},
	addNote : async (params) => {
		const url = `v2/contract/note/${params.id}`;
		return await requestv2.post(url, params);
	},
	transfer : async (params) => {
		const url = `v2/contract/transfer/${params.id}`;
		return await requestv2.post(url, params);
	},
	print : async (params) => {
		const url = `v2/contract/prints/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default contractApi;